const NavEvents = {
  PROFILE_CLICKED: {
    name: "PROFILE_CLICKED",
    category: "NAV"
  },
  HOME_CLICKED: {
    name: "HOME_CLICKED",
    category: "NAV"
  },
  TEAM_CLICKED: {
    name: "TEAM_CLICKED",
    category: "NAV"
  },
  CREDITS_CLICKED: {
    name: "CREDITS_CLICKED",
    category: "NAV"
  },
  JOB_CLICKED: {
    name: "JOB_CLICKED",
    category: "NAV"
  },
  MORE_CLICKED: {
    name: "MORE_CLICKED",
    category: "NAV"
  },

  CONTACT_SALES_CLICKED: {
    name: "CONTACT_SALES_CLICKED",
    category: "NAV"
  },
  CONTACT_SALES_CLICKED_V2: {
    name: "CONTACT_SALES_CLICKED_V2",
    category: "NAV"
  },

  FAQ_CLICKED: {
    name: "FAQ_CLICKED",
    category: "NAV"
  },
  HELP_CENTRE_CLICKED: {
    name: "HELP_CENTRE_CLICKED",
    category: "NAV"
  },
  LOGOUT_CLICKED: {
    name: "LOGOUT_CLICKED",
    category: "NAV"
  },
  JOBS_ACT_SIGN_CLICKED: {
    name: "JOBS_ACT_SIGN_CLICKED",
    category: "NAV"
  },
  COMPANY_PROFILE_CLICKED: {
    name: "COMPANY_PROFILE_CLICKED",
    category: "NAV"
  },
  COMPANY_NAME_CLEANING_CLICKED: {
    name: "COMPANY_NAME_CLEANING_CLICKED",
    category: "NAV"
  },
  CREDITS_ACTION_CLICKED: {
    name: "CREDITS_ACTION_CLICKED",
    category: "NAV"
  },
  DATABASE_CLICKED: {
    name: "DATABASE_CLICKED",
    category: "NAV"
  },
  WA_QUICK_RECRUIT_CLICKED: {
    name: "WA_QUICK_RECRUIT_CLICKED",
    category: "NAV"
  },
  FYND_DB_CLICKED: {
    name: "FYND_DB_CLICKED",
    category: "NAV"
  }
};

export default NavEvents;
